import { Router, RouterProvider } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { useAuth } from "./hooks/useAuth";
import { useAuthSync } from "./hooks/useAuthSync";

// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
        },
    },
});

// Set up a Router instance
export const router = new Router({
    routeTree,
    defaultPendingComponent: () => <div className="p-2 text-2xl">Loading...</div>,
    context: {
        auth: {
            isAuthenticated: false,
            id: "",
            isAdmin: false,
            login: () => {},
        },
    },
});

// Register things for typesafety
declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

const rootElement = document.getElementById("app");
if (!rootElement) {
    throw new Error("Root element not found");
}

function InnerApp() {
    // Sync user and profile data with auth store
    useAuthSync();

    const authState = useAuth();
    const auth = {
        isAuthenticated: authState.isAuthenticated,
        id: authState.id,
        isAdmin: authState.isAdmin,
        login: () => {},
    };

    return <RouterProvider router={router} context={{ auth }} />;
}

const root = ReactDOM.createRoot(rootElement);
root.render(
    <QueryClientProvider client={queryClient}>
        <InnerApp />
    </QueryClientProvider>
);
